import { JobStatus } from '../order'

/**
 * Job statuses (at box level) that indicate fulfilment has started
 * and the order can no longer be safely interrupted by placing it on hold.
 */
export const BLOCKED_JOB_STATUSES: string[] = [
  JobStatus.IN_PROGRESS, // Box has started packing
  JobStatus.PACKED, // Box is already packed
  JobStatus.PALLETISED, // Box is palletised,
]

/**
 * Job statuses that must not be re-routed to a different boxing station or
 * silently moved back into the backlog. Used by the boxing-station SKU
 * rebalance and manual assign/unassign paths to prevent OPS-3021 double-packs.
 *
 * - `in_progress`: claimed by a packer at a specific station; reassignment
 *   would let a second packer claim the same box.
 * - `packed`, `palletised`: terminal; must never go backwards
 * - `cancelled`: terminal; re-routing is a data-integrity issue
 */
export const NON_REASSIGNABLE_JOB_STATUSES: string[] = [
  JobStatus.IN_PROGRESS,
  JobStatus.PACKED,
  JobStatus.PALLETISED,
  JobStatus.CANCELLED,
]

/**
 * Job statuses that should NOT be counted toward today's pack workload.
 * Used to filter daily Box Management views (Box Tracker list and the
 * planned/packed progress denominator) so cancelled or held jobs don't
 * inflate the day's totals.
 */
export const NON_PACKABLE_TODAY_JOB_STATUSES: string[] = [
  JobStatus.CANCELLED,
  JobStatus.ON_HOLD,
]

/**
 * Job statuses eligible for the missing-dispatch-cutoff sweeper.
 * Pre-pack / held jobs only — excludes active queue and terminal states
 * so we don't rewrite dispatch metadata mid-pack or post-pack.
 */
export const MISSING_DISPATCH_CUTOFF_SWEEP_JOB_STATUSES: string[] = [
  JobStatus.ON_HOLD,
  JobStatus.BACKLOG,
  JobStatus.PENDING,
]
